"use client";
import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import "./components.css";
import logo from "../../public/assets/images/neoverce-white.svg";
import Image from "next/image";
import Link from "next/link";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faInstagram,
  faFacebookF,
  faTwitter,
  faLinkedinIn,
} from "@fortawesome/free-brands-svg-icons";
import {
  faEnvelope,
  faPhone,
  faLocationDot,
} from "@fortawesome/free-solid-svg-icons";
import CommonButton from "./CommonButton";
import { event } from "@/lib/analytics";
import NewsLatter from "./NewsLatter";

const quickMenuLinks = [
  { label: "Home", href: "/" },
  { label: "About Us", href: "/about" },
  { label: "Blog", href: "/blog" },
  { label: "Career", href: "/career" },
  { label: "Pricing", href: "/pricing" },
  { label: "Portfolio", href: "/portfolio" },
  { label: "Contact Us", href: "/contact" },
  { label: "Privacy policy", href: "/privacy-policy" },
];

const serviceLinks = [
  { label: "FrontEnd Development", href: "/services/frontend" },
  { label: "BackEnd Development", href: "/services/backend" },
  { label: "Database", href: "/services/database" },
  { label: "UI/UX Design", href: "/services/uiux-design" },
  { label: "Mobile App Development", href: "/services/mobile-app-development" },
  { label: "Cloud Services", href: "/services/cloud-services" },
  { label: "AI/ML", href: "/services/ai-ml" },
];

const contactInfo = [
  {
    icon: faLocationDot,
    label:
      "2055 / 56 Silver business point, VIP Circle, Uttran, Surat, Gujarat 394105.",
    href: "https://maps.app.goo.gl/cULZb7faWD13Srrf7",
  },
  {
    icon: faPhone,
    label: "+91 820-0872703",
    href: "tel:8200872703",
  },
  {
    icon: faEnvelope,
    label: "info@neoverce.com",
    href: "https://mail.google.com/mail/?view=cm&to=info@neoverce.com&su=Inquiry&body=Hi%20Neoverce%20Team,",
  },
];

const socialLinks = [
  {
    icon: faFacebookF,
    href: "https://www.facebook.com/neoverce.it.solutions?utm_source=website&utm_medium=footer&utm_campaign=social_redirect",
    label: "FacebookF",
  },
  {
    icon: faInstagram,
    href: "https://www.instagram.com/neoverce_it_solutions?utm_source=website&utm_medium=footer&utm_campaign=social_redirect",
    label: "Instagram",
  },
  // { icon: faTwitter, href: "https://twitter.com" },
  {
    icon: faLinkedinIn,
    href: "https://in.linkedin.com/company/neoverce-it-solutions-llp?utm_source=website&utm_medium=footer&utm_campaign=social_redirect",
    label: "LinkedinIn",
  },
];

const Footer = () => {
  return (
    <>
      <footer className="footer-main">
        <Container>
          <NewsLatter />
          <Row className="gy-4 pt-5">
            <Col lg={4} md={12} className="">
              <Image
                src={logo}
                alt="Neoverce"
                className="img-fluid"
                width={"auto"}
                height={50}
                priority
              />
              <p className="mt-4">
                Neoverce is a software development agency helping startups and
                enterprises build scalable digital products. From idea to
                execution, we deliver reliable web, mobile, and cloud solutions
                with precision.
              </p>
              <h4 className="footer-title mt-4">
                Follow us<span>.</span>
              </h4>
              <div className="d-flex gap-3 align-items-center">
                {socialLinks.map(({ icon, href }, idx) => (
                  <Link
                    key={idx}
                    href={href}
                    target="_blank"
                    aria-label={`open-${icon}`}
                  >
                    <FontAwesomeIcon
                      icon={icon}
                      size="lg"
                      className="social-icon"
                    />
                  </Link>
                ))}
              </div>
            </Col>

            <Col
              lg={2}
              md={4}
              sm={6}
              xs={6}
              className="d-flex flex-column gap-2"
            >
              <h4 className="footer-title">
                Quick Menu<span>.</span>
              </h4>
              {quickMenuLinks.map(({ label, href }, idx) => (
                <Link key={idx} href={href} aria-label={`open-${label}`}>
                  {label}
                </Link>
              ))}
            </Col>

            <Col
              lg={2}
              md={4}
              sm={6}
              xs={6}
              className="d-flex flex-column gap-2"
            >
              <h4 className="footer-title">
                Services<span>.</span>
              </h4>
              {serviceLinks.map(({ label, href }, idx) => (
                <Link key={idx} href={href} aria-label={`open-${label}`}>
                  {label}
                </Link>
              ))}
            </Col>

            <Col lg={4} md={4} className="d-flex flex-column gap-2">
              <h4 className="footer-title">
                Information<span>.</span>
              </h4>
              {contactInfo.map(({ icon, label, href }, idx) => (
                <Link
                  key={idx}
                  href={href}
                  target="_blank"
                  className="d-flex align-items-start gap-2"
                  aria-label={`open-${label}`}
                >
                  <FontAwesomeIcon icon={icon} className="mt-1" />
                  <span>{label}</span>
                </Link>
              ))}
            </Col>
            <Col sm={12}>
              <hr />
              <div className="text-center">
                <p className="mb-0">
                  Copyright Neoverce IT Solutions LLP © 2025. All Rights
                  Reserved.
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </footer>
    </>
  );
};

export default Footer;
